import React, { useState, useEffect } from "react"
import _ from "lodash"
// Components
import { CheckboxInput, DropdownInput, ListboxInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
// Data
import { alphanum } from "components/table/lib/sort"
import propertyService from "data/property"
// Styles
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const LeaseType = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const emptyRecord = {
    areaType: null,
    cap: null,
    floor: null
  }
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [showSelected, setShowSelected] = useState<boolean>(false);

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'byLeaseType') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    if (field === 'items'){
      let items = val
      items = items.map(item => { return { 'type': item }})
      nextData[field] = items
    } else {
      nextData[field] = val
    }
    setData(nextData);
    props.persist({...nextData, state: 'byLeaseType'}, 'areadetail', props.rowData)
  }

  const attrs           = (field) => field_attrs('area')(field)(props.rowData, props)
  const property        = propertyService.get();
  let leaseTypes        = property['leasetypedetail']
  let leaseTypesData    = _.cloneDeep(data);
  leaseTypesData        = leaseTypesData && leaseTypesData['items'] ? leaseTypesData['items'].map(item => item.type) : null
  const areaTypeOptions = [{label: 'Occupied', value: 'Occupied'},{label: 'Vacant', value: 'Vacant'},{label: 'All', value: 'All'}]

  if (showSelected && leaseTypesData){
    leaseTypes = leaseTypes.filter(leaseType => leaseTypesData.includes(leaseType.name));
  }

  function selectAll():void {
    data && data['items'] && data['items'].length === leaseTypes.length ? updateData([], 'items') : updateData(leaseTypes.map(leaseType => leaseType.name), 'items')
  }

  if (sortDirty){
    sortAsc ? leaseTypes.sort((a, b) => alphanum(a.name, b.name)) : leaseTypes.sort((a, b) => alphanum(b.name, a.name))
  }

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Area Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field='areaType' options={areaTypeOptions} persist={updateData} />
        </div>
        <div>
          <label>Floor</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="floor" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Cap</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="cap" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
      <SingleRowCarouselState_s style={{'marginTop': 20}}>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Lease Type</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: leaseTypesData ? leaseTypesData.length === leaseTypes.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": leaseTypesData}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={leaseTypes.map(leaseType => { return {label: leaseType.name, value: leaseType.name}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default LeaseType
